import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import ButtonHolder from '../molecules/ButtonHolder';
import IconArrow from '../atoms/assets/icons/IconArrow';

class WhatWillILearn extends Component {

  state = {
    redirect: false,
  };

  clickHandler = () => {
    this.setState( {
      redirect: true,
    } );
  };

  render() {
    if ( this.state.redirect ) {
      return <Redirect push to="/participant-details"/>;
    } else {
      return (
        <main>
          <h1>What will I learn?</h1>

          <p>Labeling is an important step in (supervised) machine learning, but is susceptible to bias. People see and interpret the world differently and, as such, may annotate the same piece of data differently. Bias can lead to problematic or even harmful machine learning outputs. In this example, biased labeling could cause the avatar to not look like the photo.</p>

          <p>To mitigate bias it’s important to have diverse people, diverse labels and diverse images training AI. We also need the labeling to be as consistent as possible.</p>

          <p>Failure with this exercise is intentional – the avatar and the process to create the avatar will be flawed.</p>

          <p>We encourage you to discuss with others why it is flawed – be it with other workshop participants, colleagues, friends or family.</p>

          <ButtonHolder>
          <button className="primary text button-icon" onClick={this.clickHandler}>Next<IconArrow /></button>
          </ButtonHolder>
        </main>
      )
    }
  }
}

function mapStateToProps( state ) {
  return {
    avatar: state.avatar,
  };
}

export default connect( mapStateToProps )( WhatWillILearn );
